import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeStyle } from '@angular/platform-browser';
import { CardComponent } from '../card.component';
import { Router } from '@angular/router';
// import { Attraction, AttractionList } from '../../../../generated';
// import { AttractionService } from '../../../../generated';

@Component({
  selector: 'app-attraction-card',
  templateUrl: './attraction.component.html',
  styleUrls: ['./attraction.component.scss']
})
export class AttractionCardComponent extends CardComponent implements OnInit {

  // attractionPageData: Attraction[];

  @Input() classes = 'background-dark general-dark2-bg';
  @Input() topLeftTextClasses = 'cream-super-dark';
  @Input() topRightTextClasses = 'gray2';
  @Input() titleClasses = 'white h4-nc';
  @Input() descriptionClasses = 'gray2';
  @Input() limitDescription = false;
  @Input() buttonText = 'Book Now';
  @Input() buttonClasses = 'btn-primary2';
  @Input() linkClasses = 'primary2-light';
  @Input() linkText = 'Learn More <i class=\'fas fa-arrow-right\'></i>';

  // CMS Service
  // private readonly AttractionService: AttractionService

  constructor(
      sanitize: DomSanitizer,
      router: Router) {
    super(sanitize, router);
  }

  ngOnInit() {
    // this.fetchData();
  }

  // CMS function
  // async fetchData () {
  //   const attractionList: AttractionList = await this.AttractionService.getOrgsOrgnameAttraction('global', true).toPromise();
  //   if (!!attractionList) {
  //     this.attractionPageData = attractionList;
  //   }
  // //console.log('init(): homepage data', this.attractionPageData);
  // }

}
